// extracted by mini-css-extract-plugin
export var card = "_ms-1";
export var summary = "_ms-0";
export var unreadDot = "_ms-2";